import React from "react";
import type { SidebarMenuItem } from "../types";
import { SidebarLogo } from "./SidebarLogo";
import { SidebarNavGroup } from "./SidebarNavGroup";
import { SidebarUserMenu } from "./SidebarUserMenu";

interface SidebarViewProps {
  analyzeItems: SidebarMenuItem[];
  configureItems: SidebarMenuItem[];
  utilityItems: SidebarMenuItem[];
  footerItems: SidebarMenuItem[];
  isLoading: boolean;
}

export function SidebarView({
  analyzeItems,
  configureItems,
  utilityItems,
  footerItems,
  isLoading,
}: SidebarViewProps) {
  return (
    <div className="fixed left-0 top-0 z-10 flex h-screen w-48 shrink-0 flex-col border-r border-border bg-card text-foreground">
      <SidebarLogo />

      <div className="flex w-full flex-grow flex-col justify-between overflow-y-auto pb-3">
        <div className="flex w-full flex-col gap-3 pt-2">
          {!isLoading && (
            <>
              <SidebarNavGroup items={analyzeItems} title="Analyze" />
              <SidebarNavGroup items={configureItems} title="Configure" />
              <SidebarNavGroup
                items={utilityItems}
                title="Manage"
                className="mt-1 border-t border-border pt-2"
              />
            </>
          )}
        </div>

        <div className="w-full">
          <SidebarNavGroup items={footerItems} />
          <div className="mt-2 border-t border-border pt-2">
            <SidebarUserMenu />
          </div>
        </div>
      </div>
    </div>
  );
}
